import { ISharingUser } from '@/Interfaces/SharingUser.interface';
import { IRejectValueThunkConfig } from '@/Interfaces/Slices/AsyncThunk.interface';
import { fetchSharesUsers } from '@/store/api/shares.api';
import { SearchSharesUsersPayload } from '@/types/shares.types';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { pendingCaseHandler, rejectedCaseHandler } from '../asyncThunkHandlers';

enum actionPrefix {
  FETCH = 'sharingUsersSlice/fetch',
}

interface IState {
  data: ISharingUser[];
  sharesUsersDataRequestId: null | string;
}

const initialState: IState = {
  data: [],
  sharesUsersDataRequestId: null,
};

const sharesUsersSlice = createSlice({
  name: 'sharingUsers',
  initialState,
  reducers: {
    clearSharesUsers: state => {
      state.data = initialState.data;
      state.sharesUsersDataRequestId = initialState.sharesUsersDataRequestId;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getSharesUsers.fulfilled, (state, { payload }) => {
        state.data = payload;
        state.sharesUsersDataRequestId = null;
      })
      .addCase(getSharesUsers.pending, pendingCaseHandler('sharesUsersData'))
      .addCase(getSharesUsers.rejected, rejectedCaseHandler('sharesUsersData'));
  },
});

export default sharesUsersSlice.reducer;

export const { clearSharesUsers } = sharesUsersSlice.actions;

export const getSharesUsers = createAsyncThunk<ISharingUser[], SearchSharesUsersPayload, IRejectValueThunkConfig>(
  actionPrefix.FETCH,
  async (payload, { rejectWithValue }) => {
    try {
      return await fetchSharesUsers(payload);
    } catch (err) {
      return rejectWithValue(err as Error);
    }
  },
);
